export const DropdownItemWidgetId = 'DropdownItemWidget';

export enum DropdownItemWidgetAttributes {
  VALUE = 'value',
  LABEL = 'label',
}
